import React, { Component } from 'react';
import { Button, Card, Divider, Form, message, Table } from 'antd';
import { Link } from 'react-router';

import { queryDepartmentList, querySaveDepartment } from '@api/crm/crm';
import { queryOrgList } from '@api/core/org';
import ModalDepartment from './ModalDepartment';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      modalVisible: false,
      orgList: [],
      pageNo: 1,
      total: 0,
    };
  }

  componentWillMount() {
    this.uuid = this.props.params.uuid;
  }

  componentDidMount() {
    this.getData();
    this.getOrgList();
  }

  getOrgList = () => {
    queryOrgList({
      type: 1,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          orgList: res.data,
        });
      }
    });
  };

  getData = pageNo => {
    const no = this.state.pageNo;
    const current = pageNo || no;
    this.setState({
      pageNo: current,
    });
    queryDepartmentList({
      start: current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  saveDepartment = params => {
    querySaveDepartment(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  handleChange = checked => {};

  handleSubmit = params => {
    this.saveDepartment(params);
  };

  handleModalVisible = flag => {
    this.setState({
      modalVisible: !!flag,
    });
  };

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '分属部门',
        dataIndex: 'organizationName',
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <span>
              <Link to={`/crm/department/${record.uuid}/setInfo`}>设置客户显示</Link>
              <Divider type="vertical" />
              <Link to={`/crm/department/${record.uuid}/setProtect`}>设置客户保护限制</Link>
              <Divider type="vertical" />
              <Link to={`/crm/department/${record.uuid}/stage/add`}>设置商机阶段</Link>
              <Divider type="vertical" />
              <Link to={`/crm/department/${record.uuid}/setProject`}>设置产品</Link>
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, modalVisible, orgList, total, pageNo } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.getBusiness(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListOperator">
            <Button type="primary" onClick={() => this.handleModalVisible(true)}>
              添加
            </Button>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {modalVisible ? (
          <ModalDepartment
            handleModalVisible={this.handleModalVisible}
            handleSubmit={this.handleSubmit}
            orgList={orgList}
          />
        ) : null}
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/department/Index.js